<template>
    <div class="video-modal mt-0 wallet-vidio-wrapper" v-for="(video,videoKey,index) in ($route.name == 'wallet-deposit' ? walletConfig.deposit_video : walletConfig.withdrawal_video)" :key="index">
       <div class="container p-0">
            <template v-if="video">
                <div class="thm-heading">
                    <h3>
                        {{ $route.name === 'wallet-deposit'   ? $t('how-to-deposit', 'How to Deposit') + ' (' + videoKey + ')': $t('how-to-withdraw', 'How to Withdraw') + ' (' + videoKey + ')' }}
                    </h3>
                </div>
                <div class="video-sec">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe :src="video" :title="videoKey"
                            frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
            </template>
        </div>
     </div>
</template>
<script>
export default {
	name: "WalletInstructionVideos",
    inject: ['walletConfig'],
}
</script>